// @ts-expect-error - qazaq-tili не имеет типов
import qts from "qazaq-tili";

export function formatDateForDisplay(date: Date | string | null, includeTime?: boolean): string {
  if (!date) return "";

  if (typeof date === "string") {
    date = new Date(date);
  }

  if (isNaN(date.getTime())) return "";

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");

  if (includeTime === true) {
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const hh = String(hours).padStart(2, "0");
    const mm = String(minutes).padStart(2, "0");
    return `${day}.${month}.${year}, ${hh}:${mm}`;
  }

  return `${day}.${month}.${year}`;
}

export function startOfMonth(date: Date): Date {
  return new Date(date.getFullYear(), date.getMonth(), 1);
}

export function endOfMonth(date: Date): Date {
  return new Date(date.getFullYear(), date.getMonth() + 1, 0);
}

export function formatDateToISO(date: Date | string | null): string {
  if (!date) return "";

  if (typeof date === "string") {
    date = new Date(date);
  }

  if (isNaN(date.getTime())) return "";

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
}

/** Date as the backend parses it: YYYY-MM-DD.
 *
 *  Used to delegate to formatDateForDisplay, which produced DD.MM.YYYY — the
 *  name promised an API format and handed back a human one, so every caller
 *  silently sent a payload DRF rejects. */
export function formatDateForApi(date: Date | string | null): string {
  return formatDateToISO(date);
}

export function formatDateYYYYMMDD(date: Date | string | null): string {
  return formatDateToISO(date);
}

export function formatDateForContract(
  date: Date | string | null,
  locale: "ru" | "kk" = "ru",
  shortYear: boolean = false,
  useCases: boolean = false,
): string {
  if (!date) {
    if (locale === "ru") {
      return shortYear ? "«___» __________ 20___ г." : "«___» __________ ____ года";
    } else {
      return shortYear ? "20___ жылғы «___» ______" : "____ жылғы «___» ______";
    }
  }

  if (typeof date === "string") {
    date = new Date(date);
  }

  if (isNaN(date.getTime())) {
    if (locale === "ru") {
      return shortYear ? "«___» __________ 20___ г." : "«___» __________ ____ года";
    }
    return shortYear ? "20___ жылғы «___» ______" : "____ жылғы «___» ______";
  }

  const day = date.getDate();
  const month = date.getMonth();
  const year = date.getFullYear();

  if (locale === "ru") {
    const months = [
      "января",
      "февраля",
      "марта",
      "апреля",
      "мая",
      "июня",
      "июля",
      "августа",
      "сентября",
      "октября",
      "ноября",
      "декабря",
    ];
    const monthName = months[month] || "__________";

    if (shortYear) {
      const short = String(year).slice(2);
      return `«${day}» ${monthName} 20${short} г.`;
    }

    return `«${day}» ${monthName} ${year} года`;
  }

  const monthsKz = [
    "қаңтар",
    "ақпан",
    "наурыз",
    "сәуір",
    "мамыр",
    "маусым",
    "шілде",
    "тамыз",
    "қыркүйек",
    "қазан",
    "қараша",
    "желтоқсан",
  ];

  let monthNameKz = monthsKz[month] || "______";

  if (useCases) {
    monthNameKz = qts(monthNameKz, 2);
  }

  if (shortYear) {
    const short = String(year).slice(2);
    return `20${short} жылғы «${day}» ${monthNameKz}`;
  }

  return `${year} жылғы «${day}» ${monthNameKz}`;
}

export function formatDateForLegalApi(date: Date | string | null): string {
  return formatDateToISO(date);
}

export function formatDateDDMMYYYY(date: Date | string | null): string {
  if (!date) return "";

  if (typeof date === "string") {
    date = new Date(date);
  }

  if (isNaN(date.getTime())) return "";

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");

  return `${day}.${month}.${year}`;
}

export function convertFromContractFormat(dateStr: string): string {
  if (!dateStr) return "";

  const isKazakhFormat = /^\d{2,4}\s+жылғы/.test(dateStr);

  if (isKazakhFormat) {
    const matchKz = dateStr.match(/(\d{2,4})\s+жылғы\s+«(\d{1,2})»\s+([а-яёқғңһұүіө]+)/iu);
    if (!matchKz) return "";

    const [, year, day, monthName] = matchKz;

    const processedDay = day.padStart(2, "0");
    const processedMonthName = monthName.toLowerCase();
    const processedYear = year.length === 2 ? "20" + year : year;

    const monthsKz = [
      "қаңтар",
      "ақпан",
      "наурыз",
      "сәуір",
      "мамыр",
      "маусым",
      "шілде",
      "тамыз",
      "қыркүйек",
      "қазан",
      "қараша",
      "желтоқсан",
    ];

    const monthIndex = monthsKz.findIndex((m) => processedMonthName.includes(m) || m.includes(processedMonthName));
    if (monthIndex === -1) return "";

    const month = String(monthIndex + 1).padStart(2, "0");

    return `${processedDay}.${month}.${processedYear}`;
  } else {
    const matchRu = dateStr.match(/«(\d{1,2})»\s+([А-Яа-яё]+)\s+(\d{2,4})/u);
    if (!matchRu) return "";

    const [, day, monthName, year] = matchRu;

    const processedDay = day.padStart(2, "0");
    const processedMonthName = monthName.toLowerCase();
    const processedYear = year.length === 2 ? "20" + year : year;

    const monthsRu = [
      "января",
      "февраля",
      "марта",
      "апреля",
      "мая",
      "июня",
      "июля",
      "августа",
      "сентября",
      "октября",
      "ноября",
      "декабря",
    ];

    const monthIndex = monthsRu.indexOf(processedMonthName);
    if (monthIndex === -1) return "";

    const month = String(monthIndex + 1).padStart(2, "0");

    return `${processedDay}.${month}.${processedYear}`;
  }
}

export function formatMonthYear(dateStr: string | null, locale: "ru" | "kk" | "en" = "ru"): string {
  if (!dateStr) return "";

  const date = new Date(dateStr);
  if (isNaN(date.getTime())) return "";

  const monthIndex = date.getMonth();
  const year = date.getFullYear();

  const monthsRu = [
    "Январь", "Февраль", "Март", "Апрель", "Май", "Июнь",
    "Июль", "Август", "Сентябрь", "Октябрь", "Ноябрь", "Декабрь",
  ];
  const monthsKk = [
    "Қаңтар", "Ақпан", "Наурыз", "Сәуір", "Мамыр", "Маусым",
    "Шілде", "Тамыз", "Қыркүйек", "Қазан", "Қараша", "Желтоқсан",
  ];
  const monthsEn = [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December",
  ];

  const months = locale === "kk" ? monthsKk : locale === "en" ? monthsEn : monthsRu;

  return `${months[monthIndex]} ${year}`;
}

export function formatMonthYearShort(dateStr: string | null, locale: "ru" | "kk" | "en" = "ru"): string {
  if (!dateStr) return "";

  const date = new Date(dateStr);
  if (isNaN(date.getTime())) return "";

  const monthIndex = date.getMonth();

  const monthsRu = ["Янв.", "Февр.", "Март", "Апр.", "Май", "Июнь", "Июль", "Авг.", "Сент.", "Окт.", "Нояб.", "Дек."];
  const monthsKk = ["Қаң.", "Ақп.", "Нау.", "Сәу.", "Мам.", "Мау.", "Шіл.", "Там.", "Қыр.", "Қаз.", "Қар.", "Жел."];
  const monthsEn = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

  if (locale === "kk") return monthsKk[monthIndex];
  if (locale === "en") return monthsEn[monthIndex];
  return monthsRu[monthIndex];
}

export function formatDateLong(dateStr: string, locale: "ru" | "kk" | "en" = "ru"): string {
  if (!dateStr) return "";

  const date = new Date(dateStr);
  if (isNaN(date.getTime())) return "";

  const day = date.getDate();
  const monthIndex = date.getMonth();

  const monthsRuGenitive = [
    "января", "февраля", "марта", "апреля", "мая", "июня",
    "июля", "августа", "сентября", "октября", "ноября", "декабря",
  ];
  const monthsKk = [
    "қаңтар", "ақпан", "наурыз", "сәуір", "мамыр", "маусым",
    "шілде", "тамыз", "қыркүйек", "қазан", "қараша", "желтоқсан",
  ];
  const monthsEn = [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December",
  ];

  const months = locale === "kk" ? monthsKk : locale === "en" ? monthsEn : monthsRuGenitive;

  return `${day} ${months[monthIndex]}`;
}

export function formatDateHuman(date: Date | string | null, locale: "ru" | "kk" | "en"): string {
  if (!date) return "";

  if (typeof date === "string") {
    date = new Date(date);
  }

  if (isNaN(date.getTime())) return "";

  const day = date.getDate();
  const monthIndex = date.getMonth();
  const year = date.getFullYear();
  const hh = String(date.getHours()).padStart(2, "0");
  const mm = String(date.getMinutes()).padStart(2, "0");

  const currentYear = new Date().getFullYear();
  const showYear = year !== currentYear;

  const monthsRu = [
    "января", "февраля", "марта", "апреля", "мая", "июня",
    "июля", "августа", "сентября", "октября", "ноября", "декабря",
  ];
  const monthsKk = [
    "қаңтар", "ақпан", "наурыз", "сәуір", "мамыр", "маусым",
    "шілде", "тамыз", "қыркүйек", "қазан", "қараша", "желтоқсан",
  ];
  const monthsEn = [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December",
  ];

  const months = locale === "kk" ? monthsKk : locale === "en" ? monthsEn : monthsRu;
  const monthName = months[monthIndex];

  if (locale === "en") {
    return showYear
      ? `${monthName} ${day}, ${year}, ${hh}:${mm}`
      : `${monthName} ${day}, ${hh}:${mm}`;
  }

  return showYear
    ? `${day} ${monthName} ${year}, ${hh}:${mm}`
    : `${day} ${monthName}, ${hh}:${mm}`;
}

function ruPlural(n: number, one: string, few: string, many: string): string {
  const abs = Math.abs(n);
  const mod10 = abs % 10;
  const mod100 = abs % 100;
  if (mod10 === 1 && mod100 !== 11) return `${n} ${one}`;
  if (mod10 >= 2 && mod10 <= 4 && (mod100 < 10 || mod100 >= 20)) return `${n} ${few}`;
  return `${n} ${many}`;
}

export function formatTimeAgo(date: Date | string | null, locale: "ru" | "kk" | "en" = "ru"): string {
  if (!date) return "";
  if (typeof date === "string") date = new Date(date);
  if (isNaN(date.getTime())) return "";

  const now = new Date();
  const diffMs = now.getTime() - date.getTime();
  const seconds = Math.max(0, Math.floor(diffMs / 1000));
  const minutes = Math.floor(seconds / 60);
  const hours = Math.floor(minutes / 60);
  const days = Math.floor(hours / 24);
  const weeks = Math.floor(days / 7);
  const months = Math.floor(days / 30);

  if (locale === "en") {
    if (seconds < 60) return `${seconds} second${seconds !== 1 ? "s" : ""} ago`;
    if (minutes < 60) return `${minutes} minute${minutes !== 1 ? "s" : ""} ago`;
    if (hours < 24) return `${hours} hour${hours !== 1 ? "s" : ""} ago`;
    if (days < 7) return `${days} day${days !== 1 ? "s" : ""} ago`;
    if (weeks < 5) return `${weeks} week${weeks !== 1 ? "s" : ""} ago`;
    return `${months} month${months !== 1 ? "s" : ""} ago`;
  }

  if (locale === "kk") {
    if (seconds < 60) return `${seconds} секунд бұрын`;
    if (minutes < 60) return `${minutes} минут бұрын`;
    if (hours < 24) return `${hours} сағат бұрын`;
    if (days < 7) return `${days} күн бұрын`;
    if (weeks < 5) return `${weeks} апта бұрын`;
    return `${months} ай бұрын`;
  }

  if (seconds < 60) return ruPlural(seconds, "секунду назад", "секунды назад", "секунд назад");
  if (minutes < 60) return ruPlural(minutes, "минуту назад", "минуты назад", "минут назад");
  if (hours < 24) return ruPlural(hours, "час назад", "часа назад", "часов назад");
  if (days < 7) return ruPlural(days, "день назад", "дня назад", "дней назад");
  if (weeks < 5) return ruPlural(weeks, "неделю назад", "недели назад", "недель назад");
  return ruPlural(months, "месяц назад", "месяца назад", "месяцев назад");
}

export function parseDateFromContractFormat(dateStr: string): Date | null {
  if (!dateStr) return null;
  const ddMMyyyy = convertFromContractFormat(dateStr);
  if (!ddMMyyyy) return null;
  const [day, month, year] = ddMMyyyy.split(".");
  return new Date(parseInt(year), parseInt(month) - 1, parseInt(day));
}

const ISO_DATE_PATTERN = /^(\d{4})-(\d{2})-(\d{2})$/;

export function formatIsoDateForDisplay(value: string): string {
  return value.replace(ISO_DATE_PATTERN, "$3.$2.$1");
}
